import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs/index';
import { filter } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { StorageService } from './storage.service';
import { Brand } from '../../typings';

@Injectable()
export class AppStateService {
  readonly brand$ = new BehaviorSubject<Brand>('un');
  readonly loading$ = new BehaviorSubject(true);
  readonly locale$ = new BehaviorSubject(this.translateService.getBrowserCultureLang() || 'en-US');

  constructor(
    private storageService: StorageService,
    private authService: AuthService,
    private translateService: TranslateService,
    @Inject(DOCUMENT) private document: HTMLDocument
  ) {
    this.readBrand();
    this.brand$.subscribe(brand => {
      this.updateBodyClasses();
      this.document.querySelector('link[rel="icon"]').setAttribute('href', `favicon-${brand}.ico`);
      this.saveBrand(brand);
    });
    this.authService.user$.pipe(filter((v: any) => !!v)).subscribe(user => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      if (user.brand) this.brand$.next(user.brand);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      if (user.locale) this.locale$.next(user.locale.replace('_', '-'));
    });
  }

  private saveBrand(brand: Brand) {
    if (brand !== 'co' && brand !== 'tr') {
      this.storageService.put('brand', brand);
    }
  }

  private readBrand() {
    let brand: Brand = 'un';
    if (this.storageService.contains('brand')) {
      brand = this.storageService.get<Brand>('brand');
    } else if (window.location.host.indexOf('aquent') !== -1) {
      brand = 'aq';
    }
    this.brand$.next(brand);
  }

  private updateBodyClasses() {
    let className = `brand-${this.brand$.getValue()}`;
    if (this.authService.masquerading$.getValue()) className += ' masquerading';
    this.document.body.className = className;
  }
}
